import React from 'react';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import withAttribute from './withAttribute';
import {
  DATA_ATTR_NODE_TYPE,
  NODE_TYPE_COMMERCE_CHECKOUT_CUSTOMER_INFO_WRAPPER,
} from '@packages/systems/commerce/constants';
import {SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS} from '@packages/systems/core/constants/SharedConstraintRules';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {Atom} from '@packages/systems/wfdl';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const CustomerInfoWrapper = Atom.createRender(
  ({attributes, classes, data, generateAttributes, renderChild}) => (
    <form {...generateAttributes(attributes, classes)}>
      {getChildren(data).map((child: EvaluatedNodeData) => renderChild(child))}
    </form>
  )
);

const config = createIntegratedAtom({
  displayName: 'Customer Info',
  showEmpty: true,
  render: withAttribute(
    DATA_ATTR_NODE_TYPE,
    NODE_TYPE_COMMERCE_CHECKOUT_CUSTOMER_INFO_WRAPPER
  )(CustomerInfoWrapper),
  constraints: {
    ancestors: [
      ...SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
      {is: 'CommerceCheckoutFormContainer', rule: 'ExactlyOne'},
    ],
    descendants: [
      ...SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
      {is: 'CommerceCheckoutEmailInput', rule: 'ExactlyOne'},
    ],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginBottom: px(20),
        },
      },
    },
  },
  fields: {children: TListOfElement},
});

export default config;
